import React from 'react';
import moment from 'moment';
import { LEGAL_ADVICE_TEXT, TOBA_SHORT_TEXT } from '../../helpers/variables';
import { FormGroup, Heading, List, Loader, Button, FormInline } from 'arag-ui-lib';
import { FORM_GROUP_VARIANTS } from '../../helpers/formGroupVariants';
import { DOTS, DOWNLOAD, HEADING_4, MEDIUM, MOMENT_DATE_TIME_FORMAT, MOMENT_DATE_TIME_FORMAT_12_HOUR, PRIMARY, RIGHT } from '../../helpers/constants';
import CONTENT_STRINGS from '../../helpers/contentStrings';

const TobaRevision = (props) => {
    const {
        fetchingTobaRevision,
        tobaRevision,
        defaultToba,
        _getFileFromBase64,
        populateTobaFormFromRevision,
    } = props;

    if(fetchingTobaRevision){
        return <Loader variant={DOTS} dotSize={MEDIUM} />;
    }

    const handleDownloadClick = (attachment) => () => _getFileFromBase64(attachment);
    const handlePopulateFormClick = () => populateTobaFormFromRevision({tobaRevision});
    const getSolicitorGroupListItem = (d) => ({
        id: d.id,
        content: <>{d.name} {moment(d.startDate).format(MOMENT_DATE_TIME_FORMAT_12_HOUR)} - {d.expiryDate!==null?moment(d.expiryDate).format(MOMENT_DATE_TIME_FORMAT_12_HOUR):null}</>
    });

    const getTobaAttachmentListItem = (attachments, index) => ({
        id: index,
        linkItemTestId: `toba-modal-attached-files-${index}`,
        content: <div key={index} style={{display: 'flex', gap: '10px'}}>
            <Button
                variant={DOWNLOAD}
                label={CONTENT_STRINGS.DOWNLOAD}
                onClick={handleDownloadClick(attachments)}
            />
            <FormInline
                variant={FORM_GROUP_VARIANTS.PLAIN}
                label={attachments.name}
                inputProps={{
                    id: `toba-attachment-${index}`,
                    name: `toba-attachment-${index}`,
                }}
            />
        </div>
    });

    const solicitorGroupListItems = (tobaRevision.solicitorGroupDtos || []).map(getSolicitorGroupListItem);
    const tobaRevisionListItems = (tobaRevision.tobaAttachmentDtos || []).map(getTobaAttachmentListItem);

    return (
        <form className={'form-horizontal'}>
            <FormGroup
                labelSize={"col-sm-3"}
                inputSize={"col-sm-9"}
                variant={FORM_GROUP_VARIANTS.PLAIN}
                label={CONTENT_STRINGS.NAME}
                inputProps={{
                    id: 'toba-revision-name',
                    name: 'toba-revision-name',
                    label: tobaRevision.name
                }}
                formGroupTestId={'toba-modal-name'}
            />
            <FormGroup
                labelSize={"col-sm-3"}
                inputSize={"col-sm-9"}
                variant={FORM_GROUP_VARIANTS.PLAIN}
                label={CONTENT_STRINGS.VERSION_NAME}
                inputProps={{
                    id: 'toba-revision-version',
                    name: 'toba-revision-version',
                    label: tobaRevision.version
                }}
                formGroupTestId={'toba-modal-version-name'}
            />
            {
                defaultToba
                ?
                    null
                :
                    <FormGroup
                        labelSize={"col-sm-3"}
                        inputSize={"col-sm-9"}
                        variant={FORM_GROUP_VARIANTS.PLAIN}
                        label={`${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.GROUPS}`}
                        inputProps={{
                            id: 'toba-revision-groups',
                            name: 'toba-revision-groups',
                            label: <List
                                items={solicitorGroupListItems}
                                variant={FORM_GROUP_VARIANTS.PLAIN}
                                //listTestId={''}
                            />
                        }}
                        formGroupTestId={'toba-modal-solicitor-groups'}
                    />
            }
            <FormGroup
                labelSize={"col-sm-3"}
                inputSize={"col-sm-9"}
                variant={FORM_GROUP_VARIANTS.PLAIN}
                label={CONTENT_STRINGS.CONTENT_LABEL}
                inputProps={{
                    id: 'toba-revision-content',
                    name: 'toba-revision-content',
                    label: <div dangerouslySetInnerHTML={{__html: tobaRevision.content}}></div>
                }}
                formGroupTestId={'toba-modal-content'}
            />
            <FormGroup
                labelSize={"col-sm-3"}
                inputSize={"col-sm-9"}
                variant={FORM_GROUP_VARIANTS.PLAIN}
                label={CONTENT_STRINGS.VALID_FROM}
                inputProps={{
                    id: 'toba-revision-valid-from',
                    name: 'toba-revision-valid-from',
                    label: moment(tobaRevision.validFrom).format(MOMENT_DATE_TIME_FORMAT)
                }}
                formGroupTestId={'toba-modal-valid-from'}
            />
            <FormGroup
                labelSize={"col-sm-3"}
                inputSize={"col-sm-9"}
                variant={FORM_GROUP_VARIANTS.PLAIN}
                label={CONTENT_STRINGS.EXPIRY_DATE}
                inputProps={{
                    id: 'toba-revision-expiry-date',
                    name: 'toba-revision-expiry-date',
                    label: tobaRevision.validUntil ? moment(tobaRevision.validUntil).format(MOMENT_DATE_TIME_FORMAT) : ''
                }}
                formGroupTestId={'toba-modal-expiry'}
            />
            {
                tobaRevision.tobaAttachmentDtos
                ?
                    tobaRevision.tobaAttachmentDtos.length > 0
                    ?
                        <div className="row">
                            <div className="col-sm-12">
                                <Heading
                                    variant={HEADING_4}
                                    title={CONTENT_STRINGS.FILES_ATTACHED}
                                />
                                <List
                                    items={tobaRevisionListItems}
                                    variant={FORM_GROUP_VARIANTS.PLAIN}
                                    listTestId={'toba-modal-attached-files'}
                                />
                            </div>
                        </div>
                    :
                        null
                :
                    null
            }
            <div className={'form-group'}>
                <div className={'col-sm-9 col-sm-offset-3'}>
                    <Button
                        label={`${CONTENT_STRINGS.POPULATE_EDIT_FORM_FROM_REVISION} ${TOBA_SHORT_TEXT}`}
                        onClick={handlePopulateFormClick}
                        variant={PRIMARY}
                        arrowDirection={RIGHT}
                        buttonTestId={'toba-modal-populate'}
                    />
                </div>
            </div>
        </form>
    )
};

export default TobaRevision;